// extracted by mini-css-extract-plugin
module.exports = {"container":"errorBlock_container__3A0HT"};
    if(module.hot) {
      // 1783591925890
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  